import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgScatterPlot = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1024 1024",
	fill: "none",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M580 750q0-52 38-90t90-38 90 38 38 90-38 90-90 38-90-38-38-90zM342 256q0-52 38-90t90-38 90 38 38 90-38 90-90 38-90-38-38-90zM170 598q0-52 38-90t90-38 90 38 38 90-38 90-90 38-90-38-38-90z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgScatterPlot);
export default ForwardRef;
